<!--
 * @Author: Lijiahui
 * @Date: 2020-10-16 10:43:57
 * @LastEditors: Lijiahui
 * @LastEditTime: 2020-10-20 00:07:02
-->
<template>
  <div class="headerBox">
    <div class="left">
      <img src="@/assets/images/logo.png" alt="">
      <div>走读庐阳管理后台</div>
    </div>
    <div class="right">
      欢迎登陆
    </div>
  </div>
  <div class="login_bck">
    <div class="login_content">
      <!--<div class="title_1">欢迎登录</div>-->
      <el-tabs v-model="activeName">
        <el-tab-pane  name="first">
          <tabsPsd ref="tabsPsd" />
        </el-tab-pane>
        <!--<el-tab-pane label="手机" name="second">
          <tabsPhone ref="tabsPhone" />
        </el-tab-pane>-->
      </el-tabs>
      <div class="regest">
        <!-- 立即注册 -->
        <!-- <span>还没有账号？<a class="target">立即注册</a></span> -->
      </div>
    </div>
  </div>
  <div class="footer">
    安徽乾景旅游文化创意有限责任公司
  </div>
</template>

<script>
  import login from './js/login'
  export default {
    ...login
  }
</script>
<style lang='less' scoped>
  @import "./css/login.less";
</style>
